/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateSpendRuleRequestBody,
  UpdateSpendRuleRequestBody$Outbound,
  UpdateSpendRuleRequestBody$outboundSchema,
} from "../components/updatespendrulerequestbody.js";

export type UpdateSpendRuleSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateSpendRuleSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateSpendRuleSecurity = {
  option1?: UpdateSpendRuleSecurityOption1 | undefined;
  option2?: UpdateSpendRuleSecurityOption2 | undefined;
};

export type UpdateSpendRuleRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateSpendRuleRequestBody: UpdateSpendRuleRequestBody;
};

/** @internal */
export type UpdateSpendRuleSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateSpendRuleSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateSpendRuleSecurityOption1$Outbound,
  UpdateSpendRuleSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateSpendRuleSecurityOption1ToJSON(
  updateSpendRuleSecurityOption1: UpdateSpendRuleSecurityOption1,
): string {
  return JSON.stringify(
    UpdateSpendRuleSecurityOption1$outboundSchema.parse(
      updateSpendRuleSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateSpendRuleSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateSpendRuleSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateSpendRuleSecurityOption2$Outbound,
  UpdateSpendRuleSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateSpendRuleSecurityOption2ToJSON(
  updateSpendRuleSecurityOption2: UpdateSpendRuleSecurityOption2,
): string {
  return JSON.stringify(
    UpdateSpendRuleSecurityOption2$outboundSchema.parse(
      updateSpendRuleSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateSpendRuleSecurity$Outbound = {
  Option1?: UpdateSpendRuleSecurityOption1$Outbound | undefined;
  Option2?: UpdateSpendRuleSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateSpendRuleSecurity$outboundSchema: z.ZodMiniType<
  UpdateSpendRuleSecurity$Outbound,
  UpdateSpendRuleSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateSpendRuleSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateSpendRuleSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateSpendRuleSecurityToJSON(
  updateSpendRuleSecurity: UpdateSpendRuleSecurity,
): string {
  return JSON.stringify(
    UpdateSpendRuleSecurity$outboundSchema.parse(updateSpendRuleSecurity),
  );
}

/** @internal */
export type UpdateSpendRuleRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateSpendRuleRequestBody: UpdateSpendRuleRequestBody$Outbound;
};

/** @internal */
export const UpdateSpendRuleRequest$outboundSchema: z.ZodMiniType<
  UpdateSpendRuleRequest$Outbound,
  UpdateSpendRuleRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateSpendRuleRequestBody: UpdateSpendRuleRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updateSpendRuleRequestBody: "UpdateSpendRuleRequestBody",
    });
  }),
);

export function updateSpendRuleRequestToJSON(
  updateSpendRuleRequest: UpdateSpendRuleRequest,
): string {
  return JSON.stringify(
    UpdateSpendRuleRequest$outboundSchema.parse(updateSpendRuleRequest),
  );
}
